import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { Section as MenuSection } from '@atlaskit/menu';
import { sectionHeaderStyle } from '../../common/styles';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context'; // Type needed on props to extract types with extract react types.

var Section = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useShouldNestedEleme = useShouldNestedElementRender(),
      shouldRender = _useShouldNestedEleme.shouldRender;

  if (!shouldRender) {
    return props.children;
  }

  return /*#__PURE__*/React.createElement(MenuSection, _extends({}, props, {
    ref: ref,
    overrides: {
      HeadingItem: {
        cssFn: sectionHeaderStyle
      }
    }
  }));
});
export default Section;